import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';

class Labor extends ChemComponent {
	constructor(props) {
		super(props);
		
		var labor = {
			SHOP_ID: props.params.shopId,
			EMPLOYEE_ID: null,
			JOB_ID: null,
			LABOR_TIME: '',
			COMMENTS: '',
			JOB_DATE: this.dateTimeToMVC(new Date()),
			ORDER_BY: ['JOB_DATE desc','UPDATE_DATE desc']
		};
		
		var laborEntryInit = this.copyColumns(laborEntry);
		laborEntryInit[0].options.search = { Attribute: 'SHOP_ID', Operator: '=', LongValue: props.params.shopId };
		laborEntryInit[1].options.search = { Attribute: 'SHOP_ID', Operator: '=', LongValue: props.params.shopId };
		
		var laborListInit = this.copyTable(laborList);
		laborListInit.query.search = this.constructSearch(labor);
		laborListInit.query.order = labor.ORDER_BY;

		this.state = {
			labor: labor,
			laborEntry: laborEntryInit,
			laborList: laborListInit,
			searchCount: null,
			renderKey: 0
		};
	}
	
	viewJob(jobId) {
		this.props.setJobEditable(false);
		this.props.navigate('/Jobtrack/Jobs/' + jobId);
	}

	onChangeSearch(accessor, value) {
		var labor = this.copyObject(this.state.labor);
		this.setByAccessor(labor, accessor, value);
		this.mergeState({ labor: labor });
	}

	constructSearch(data) {
		return ({ Attribute: 'SHOP_ID', Operator: '=', LongValue: this.props.params.shopId });
	}
	
	addLaborEntry() {
		var self = this;
		
		// send labor entry to server
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/AddLaborEntry',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				labor: this.state.labor
			}
		}).done(function (data) {
			if (data.Success) {		
				// update state so that unbilled labor table will reload
				self.mergeState({
					searchCount: null,
					renderKey: self.state.renderKey + 1
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	onSubmitSearch(event, newOrderBy) {
		// copy labor in case we need to incorporate the new ordering
		var labor = this.copyObject(this.state.labor);
		var newLaborList = this.copyTable(laborList);
		newLaborList.query.search = this.constructSearch(labor);
		if (newOrderBy) {
			labor.ORDER_BY = newOrderBy;
			newLaborList.query.order = newOrderBy;
		}
		
		this.mergeState({
		    labor: labor,
		    laborList: newLaborList,
		    showSearch: false,
		    searchCount: null,
		    renderKey: this.state.renderKey + 1
	    });
	}
	
    onSearchResult(data) {
        this.mergeState({
            searchCount: data.ResultCount
		});
	}
			
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Unbilled Labor',
			columns: exportColumns,
			entity: 'RECHARGES.UNBILLED_LABOR_VW',
			search: this.constructSearch(this.state.labor),
			order: this.state.labor.ORDER_BY
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Time Card Entry for Shop</div>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.laborEntry} data={this.state.labor}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" 
						  onClick={() => this.addLaborEntry()}>Save</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
                  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Unbilled_Labor' table={this.state.laborList}
                    order={this.state.labor.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
                    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const laborEntry = [
	{ Header: 'Employee', accessor: 'EMPLOYEE_ID', type: 'select', row: 0, col: 0, required: true,
		options: { value: 'EMP_ID', label: 'EMP_NAME', entity: 'RECHARGES.SHOP_EMP_SELECT_VW', order: 'EMP_NAME' }},
	{ Header: 'Job', accessor: 'JOB_ID', type: 'select', row: 0, col: 1, required: true,
		options: { value: 'JOB_ID', label: 'JOB_INFO', entity: 'RECHARGES.SHOP_JOB_SELECT_VW', order: 'JOB_ID desc' }},
	{ Header: 'Hrs', accessor: 'LABOR_TIME', row: 0, col: 2, required: true },
	{ Header: 'Remarks', accessor: 'COMMENTS', type: 'textarea', row: 1, col: 0, colwidth: 8 },
	{ Header: 'Date', accessor: 'JOB_DATE', type: 'date', row: 1, col: 2, required: true }
];

const laborList = {
	query: { entity: 'RECHARGES.UNBILLED_LABOR_VW' },
	pageSize: 20,
	columns: [
		{ Header: '', accessor: 'JOB_ID', show: false },
		{ Header: 'Job ID / Description', accessor: 'JOB_INFO', width: 300,
			Cell: props => <HashLink onClick={() => props.parent.viewJob(props.row.values.JOB_ID)}>{props.value}</HashLink> },
		{ Header: 'Hrs', accessor: 'LABOR_TIME', width: 60 },
		{ Header: 'Employee', accessor: 'EMP_NAME', width: 200 },
		{ Header: 'Customer', accessor: 'CUSTOMER_NAME', width: 200 },
		{ Header: 'Remarks', accessor: 'COMMENTS', width: 200 },
		{ Header: 'Trans Date', accessor: 'JOB_DATE', width: 100,
			Cell: props => props.parent.dateToString(props.value) },
		{ Header: 'Status', accessor: 'READY_TO_BILL', width: 100 },
		{ Header: 'Last Update', accessor: 'UPDATE_DATE', width: 100,
			Cell: props => props.parent.dateToString(props.value) }
	]
};

const exportColumns = [
	{ Header: 'Labor ID', accessor: 'LABOR_ID', width: 25 },
	{ Header: 'Shop ID', accessor: 'SHOP_ID', width: 25 },
	{ Header: 'Labor Time', accessor: 'LABOR_TIME', width: 25 },
	{ Header: 'Employee ID', accessor: 'EMPLOYEE_ID', width: 25 },
	{ Header: 'Job ID', accessor: 'JOB_ID', width: 25 },
	{ Header: 'Employee Name', accessor: 'EMP_NAME', width: 25 },
	{ Header: 'Job Info', accessor: 'JOB_INFO', width: 25 },
	{ Header: 'Job Date', accessor: 'JOB_DATE', width: 25 },
	{ Header: 'Ready to Bill', accessor: 'READY_TO_BILL', width: 25 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 25 },
	{ Header: 'Created By', accessor: 'CREATED_BY', width: 25 },
	{ Header: 'Date Created', accessor: 'DATE_CREATED', width: 25, format: 'mm/dd/yyyy' },
	{ Header: 'Update Date', accessor: 'UPDATE_DATE', width: 25, format: 'mm/dd/yyyy' },
	{ Header: 'Modified By', accessor: 'MODIF_BY', width: 25 },
	{ Header: 'Customer Name', accessor: 'CUSTOMER_NAME', width: 25 },
];

export default withRouter(Labor);
